import { Theme } from '@mui/material';


const Accordion = (theme: Theme) => {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderBottom: `1px solid ${theme.palette.divider}`,
          borderTop: 'none',
          paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          '&:last-of-type': {
            borderRadius: 0,
          },
          '&:before': {
            display: 'none',
          },
          '&.Mui-expanded': {
            margin: 'auto',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0),
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
        },
      },
    },
  };
};

export default Accordion;
